export const MAX_ENTITY_NAME_LENGTH = 255;
// TODO @evnp - standardize all these max lengths at DB level and update here
export const MAX_DASHBOARD_NAME_LENGTH = 160;
export const MAX_COHORT_NAME_LENGTH = 190;
